import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, X } from "lucide-react";

const KEY = "prosperr_cookie_consent_v1";

/**
 * Minimal, RGPD-compliant cookie banner.
 * Only essential cookies are used (session, CSRF) — no tracking/ads.
 * User choice persists in localStorage.
 */
export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(KEY);
      if (!v) setVisible(true);
    } catch { /* noop */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, "accepted-" + new Date().toISOString()); } catch (_) { /* swallow: non-fatal */ }
    setVisible(false);
  };

  const dismiss = () => {
    try { localStorage.setItem(KEY, "dismissed-" + new Date().toISOString()); } catch (_) { /* swallow: non-fatal */ }
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Politique cookies"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md z-[60] bg-[#121214] text-white rounded-xl p-5 shadow-[0_20px_45px_rgba(0,0,0,0.55)] border border-zinc-800"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg border border-zinc-800 bg-[#18181B] grid place-items-center shrink-0">
          <ShieldCheck className="w-4 h-4 text-emerald-400" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="hp-label mb-1" style={{ color: "#A1A1AA" }}>Confidentialité</div>
          <div className="font-display font-semibold text-[15px] leading-tight text-white">Cookies techniques uniquement</div>
          <p className="text-[13px] text-zinc-400 mt-1.5 leading-relaxed">
            Prosperr utilise uniquement des cookies de session et d'authentification. <span className="text-zinc-200">Aucun tracker publicitaire</span>, aucun transfert de données hors UE.
          </p>
          <div className="flex gap-2 mt-4">
            <button
              onClick={accept}
              data-testid="cookie-accept"
              className="flex-1 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg h-10 text-sm font-medium transition-colors"
            >
              Accepter
            </button>
            <Link
              to="/privacy"
              data-testid="cookie-learn-more"
              className="rounded-lg border border-zinc-800 bg-zinc-900/40 hover:bg-zinc-900 hover:border-zinc-700 px-4 h-10 grid place-items-center text-sm font-medium text-zinc-300 transition-colors"
            >
              En savoir plus
            </Link>
          </div>
        </div>
        <button
          onClick={dismiss}
          aria-label="Fermer"
          className="w-7 h-7 rounded-md hover:bg-zinc-800 grid place-items-center shrink-0 transition-colors text-zinc-400"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
